// @flow

import 'isomorphic-fetch'
import { getApiBaseUrlWithOrg, getApiHeaders, checkHttpStatus } from '../utils'
import { getErrorAction } from '../utils/actions'
import { basicGet } from '../utils/api'
import type { Action } from '../types/actions/topics'
import type { APIError } from '../types'

export const SEARCH_TOPICS_SUCCESS = 'SEARCH_TOPICS_SUCCESS'
export const SEARCH_TOPICS_REQUEST = 'SEARCH_TOPICS_REQUEST'
export const SEARCH_TOPICS_FAILURE = 'SEARCH_TOPICS_FAILURE'
export const DELETE_TOPIC_SUCCESS = 'DELETE_TOPIC_SUCCESS'
export const EDIT_TOPIC_CONTEXT_SUCCESS = 'EDIT_TOPIC_CONTEXT_SUCCESS'
export const ADD_TOPIC_SUCCESS = 'ADD_TOPIC_SUCCESS'
export const REQUEST_QUEST_TOPICS = 'REQUEST_QUEST_TOPICS'
export const RECEIVE_QUEST_TOPICS = 'RECEIVE_QUEST_TOPICS'
export const FAILED_QUEST_TOPICS = 'FAILED_QUEST_TOPICS'

export function searchTopicsRequest(): Action {
  return {
    type: SEARCH_TOPICS_REQUEST
  }
}

export function searchTopicsSuccess(response: {
  topics: Array<Object>
}): Action {
  return {
    type: SEARCH_TOPICS_SUCCESS,
    topics: response.topics
  }
}

export function searchTopicsFailure(error: APIError): Action {
  return getErrorAction(SEARCH_TOPICS_FAILURE, error)
}

export function addTopicSuccess(response: Object): Action {
  return {
    type: ADD_TOPIC_SUCCESS,
    topic: response
  }
}

export function editTopicContextSuccess(response: Object): Action {
  return {
    type: EDIT_TOPIC_CONTEXT_SUCCESS,
    topic: response
  }
}

export function deleteTopicSuccess(topicId: number): Action {
  return {
    type: DELETE_TOPIC_SUCCESS,
    topicId: topicId
  }
}

export function requestQuestTopics(): Action {
  return {
    type: REQUEST_QUEST_TOPICS
  }
}

export function receiveQuestTopics(response: Object): Action {
  return {
    type: RECEIVE_QUEST_TOPICS,
    topics: response.topics
  }
}

export function failedQuestTopics(error: APIError): Action {
  return getErrorAction(FAILED_QUEST_TOPICS, error)
}

export function searchTopics(query: string): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(searchTopicsRequest())
    try {
      const response = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(state.organization.orgId)}/topics/search`,
          {
            method: 'POST',
            headers: getApiHeaders(state),
            body: JSON.stringify({
              q: {
                name_or_description_cont: query
              }
            })
          }
        )
      )

      const json = await response.json()
      dispatch(searchTopicsSuccess(json))
    } catch (error) {
      dispatch(searchTopicsFailure(error))
    }
  }
}

export function fetchQuestTopics(id: number, state: Object): Function {
  return dispatch => {
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${id}/topics`
    return basicGet(
      state,
      dispatch,
      url,
      requestQuestTopics,
      receiveQuestTopics,
      failedQuestTopics
    )
  }
}

export function deleteTopic(questId: number, topicId: number): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/topics/${topicId}`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: getApiHeaders(state)
        })
      )
      dispatch(deleteTopicSuccess(topicId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function changeTopicContext(
  questId: number,
  topicId: number,
  context: string
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/topics/${topicId}`
    let data = new FormData()
    data.append('topic_quest[context]', context)
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/vnd.oefngl.v3'
          },
          body: data
        })
      )
      const json = await response.json()
      dispatch(editTopicContextSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function addTopic(
  questId: number,
  topicId: number,
  context: string
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/topics`
    let data = new FormData()
    data.append('topic_quest[topic_id]', topicId.toString())
    data.append('topic_quest[context]', context)
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/vnd.oefngl.v3'
          },
          body: data
        })
      )
      const json = await response.json()
      dispatch(addTopicSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/topics.js